import { store } from "@/config"
import { PERMISSION_DENY, OTAS_WITH_COMPANY_SYSTEM, EMERGENCY_STOP_OTAS } from "@/config/constants"

export const hasPermission = (permissionType, accessType, permissionsScope = store.state.currentUser.permissions) => {
  const targetPermission = permissionsScope[permissionType]

  return targetPermission === accessType || (accessType === PERMISSION_DENY && targetPermission === undefined)
}

export const isSuperadmin = () => !!store.state.currentUser.superadmin

export const isOrganizationAdmin = () => !!store.state.currentUser.organization_admin

export const isOtaAdmin = () => !!store.state.currentUser.ota_admin

export const isCompanyOtaAdmin = () =>
  isOtaAdmin() && OTAS_WITH_COMPANY_SYSTEM.includes(store.state.currentUser.ota_name)

export const isEmergencyAdmin = () => isOtaAdmin() && EMERGENCY_STOP_OTAS.includes(store.state.currentUser.ota_name)

export const isToyotaOrganizationAdmin = () => !!store.state.currentUser.toyota_organization_admin

export const isNipponOrganizationAdmin = () => !!store.state.currentUser.nippon_organization_admin
